import { LcmsApiUtil } from '@/shared/api';

/** 교과서 목록 조회 */
export const getTextbookLcms = {
    getTextbookList: (param: API.TextbookList.Req) => {
        return LcmsApiUtil.get<API.TextbookList.Res>('/api/textbook/textbookList', param);
    },

    postTextbookList: (param: API.TextbookList.Req) => {
        return LcmsApiUtil.post<API.TextbookList.Res>('/api/textbook/textbookList', param);
    },

    postTextbookListbyCurriBook: (param: API.TextbookListbyCurriBook.Req) => {
        return LcmsApiUtil.post<API.TextbookListbyCurriBook.Res>(
            '/api/textbook/textbookListbyCurriBook',
            param
        );
    },

    postCurriBookMeta: (param: API.CurriBookMeta.Req) => {
        return LcmsApiUtil.post<API.CurriBookMeta.Res>('/api/system/meta/curriBook', param);
    },

    getMetaList: (param: API.MetaList.Req) => {
        return LcmsApiUtil.get<API.MetaList.Res>('/api/system/meta/list', param);
    },
    // 교과 API
    postTextbookSubject: (param: API.TextbookSubject.Req) => {
        return LcmsApiUtil.post<API.TextbookSubject.Res>('/api/textbook/curriSubject', param);
    },
    postSetSearchEx: (param: API.SetSearchEx.Req) => {
        return LcmsApiUtil.post<API.SetSearchEx.Res>('/api/contents/setSearchEx', param);
    },
    postArticleSearchEx: (param: API.ArticleSearchEx.Req) => {
        return LcmsApiUtil.post<API.ArticleSearchEx.Res>('/api/contents/articleSearchEx', param);
    },
};
